import { Injectable, inject } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { CityService } from './city.service';

@Injectable({
    providedIn: 'root'
})
export class SocketService {
    private readonly cityService = inject(CityService);
    private socket: Socket;

    constructor() {
        // Use a placeholder URL — connectToCity() sets the real URL after cityService.resolve().
        this.socket = io('https://placeholder.invalid', {
            transports: ['websocket'],
            autoConnect: false,
            reconnection: true,
            reconnectionAttempts: 10,
            reconnectionDelay: 1000
        });

        this.socket.on('connect', () => {
            console.log('[Socket] SUCCESSFULLY Connected to backend. ID:', this.socket.id);
        });

        this.socket.on('connect_error', (error) => {
            console.error('[Socket] CONNECTION ERROR:', error);
        });

        this.socket.on('disconnect', (reason) => {
            console.warn('[Socket] Disconnected from backend. Reason:', reason);
        });
    }

    /**
     * Called once from app.component after cityService.resolve() completes.
     * Updates the socket URL to the resolved city's API and opens the connection.
     */
    connectToCity(): void {
        const url = this.cityService.apiBaseUrl();
        (this.socket as any).io.uri = url;
        console.log('[Socket] Initializing connection to:', url);
        this.socket.connect();
    }

    get isConnected(): boolean {
        return this.socket.connected;
    }

    /**
     * Call once after login (or on app resume when token is available).
     * Sets the JWT in the socket handshake so the gateway can authenticate
     * the driver and accept update-location events.
     */
    authenticate(token: string) {
        (this.socket as any).auth = { token };
        // Reconnect so the server receives the authenticated handshake.
        // Socket.IO buffers any emits queued after this and sends them once connected.
        this.socket.disconnect().connect();
    }

    emit(event: string, data: any) {
        this.socket.emit(event, data);
    }

    on(event: string, callback: (data: any) => void) {
        this.socket.on(event, callback);
    }

    off(event: string, callback: (data: any) => void) {
        this.socket.off(event, callback);
    }

    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
        }
    }
}
